<!--
 * @Author: your name
 * @Date: 2021-11-25 15:43:49
 * @LastEditTime: 2021-11-26 17:10:11
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \kares_pad\src\components\system\children\HelpChild.vue
-->
<template>
  <div class="file-content">
    <a :href="'http://admin.kystarcloud.com/upload/help/'+url+name">
      <img v-if="type === 'mp4'" src="@/assets/images/help/MP4.png" alt />
      <img v-if="type === 'pdf'" src="@/assets/images/help/pdf.png" alt />
      <div>{{name}}</div>
    </a>
  </div>
</template>

<script>
export default {
  name: "HelpChild",
  props: {
    type: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
  }

}
</script>

<style lang="scss" scoped>
.file-content {
  display: flex;
  flex-direction: column;
  text-align: center;
  margin: 8px 0px;
  width: 120px;
  img {
    height: 70px;
  }
  span {
    padding: 4px;
  }
}
</style>